import { Question } from "../types";

export type EmqSidebarGroupPosition =
  | "none"
  | "only"
  | "start"
  | "middle"
  | "end";

/** Where this question sits within a contiguous EMQ grouping in the sidebar list. */
export function getEmqSidebarGroupPosition(
  questions: Question[],
  index: number,
): EmqSidebarGroupPosition {
  const question = questions[index];
  const groupingId = question?.emqPart?.groupingId;
  if (groupingId == null) {
    return "none";
  }

  const prevSame = questions[index - 1]?.emqPart?.groupingId === groupingId;
  const nextSame = questions[index + 1]?.emqPart?.groupingId === groupingId;

  if (!prevSame && !nextSame) return "only";
  if (!prevSame && nextSame) return "start";
  if (prevSame && nextSame) return "middle";
  return "end";
}

export function getEmqSidebarItemClassName(
  questions: Question[],
  index: number,
): string {
  const position = getEmqSidebarGroupPosition(questions, index);
  if (position === "none") return "";
  return `sidebar-q--emq sidebar-q--emq-${position}`;
}
